<template>
	<div v-if="pallet">
		<CModal title="Modifier la palette" size="lg" :show.sync="showModal">
			<form
				ref="mainForm"
				:action="['/api/pallets/', pallet.id].join('')"
				method="post"
				axiosMethod="patch">
				<FormContent v-if="showModal" ref="form" :pallet="pallet" :key="pallet.id" />
			</form>

			<template #footer>
				<CButton color="secondary" v-on:click="showModal = false">Annuler</CButton>
				<CButton color="success" v-on:click="onSubmit($refs.mainForm)">Sauvegarder</CButton>
			</template>
		</CModal>
	</div>
</template>

<script>
	import FormContent from './PalletForm';

	export default {
		components: {
			FormContent,
		},
		data() {
			return {
				showModal: false,
				pallet: null,
			};
		},

		methods: {
			onSubmit: function (form) {
				this.$formDataToApi
					.sendForm(form, {
						weightLimit: this.$refs.form.weightLimit, // force send nullable values
						volumeLimit: this.$refs.form.volumeLimit,
						quantityLimit: this.$refs.form.quantityLimit,
					})
					.then(res => {
						if (res.status === 200 || res.status === 201) {
							this.$toast.success('Palette modifiée avec succès !');
							this.showModal = false;
							this.$emit('refresh');
						} else {
							this.$toast.error(res.data['hydra:description']);
						}
					});
			},
		},
	};
</script>
